/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackItemRequestSchema } from "./pluginPostbackItemRequestSchema.ts";

export const pluginPostbackRequestSchema = z.object({
	orderId: z.uuid(),
	items: z.array(pluginPostbackItemRequestSchema),
	orderNumber: z.int(),
	isDeleted: z.boolean(),
	cardNumber: z.string().nullish().default(""),
	tabName: z.string().nullish(),
});
